import type { IconProps } from '../types';

export function HomeIcon({ className, title }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 125"
      preserveAspectRatio="xMidYMid meet"
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
    >
      {title ? <title>{title}</title> : null}
      <g>
        <path
          d="M95.4,52.1L52.6,17.4c-1.5-1.2-3.7-1.2-5.2,0L4.6,52.1c-0.9,0.7-1,2-0.3,2.8c0.7,0.9,2,1,2.8,0.3l6.1-4.9v34.2 c0,2.2,1.8,4,4,4h65.6c2.2,0,4-1.8,4-4V50.3l6.1,4.9c0.4,0.3,0.8,0.4,1.3,0.4c0.6,0,1.2-0.3,1.6-0.7C96.4,54.1,96.3,52.8,95.4,52.1z M58.3,84.5H41.7V63.9h16.6V84.5z M82.8,84.5H62.3V61.9c0-1.1-0.9-2-2-2H39.7c-1.1,0-2,0.9-2,2v22.6H17.2V47.1L50,20.5l32.8,26.6 V84.5z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
